import { find, findIndex } from "lodash";
import { FormData, FormData_layouts as FormLayout, FormLayoutName } from "types/gql-types";
import { QuestionProps } from "./question";


export const keyFromIdentity =
(identity: string | string[], parent?: string, index?: number): string => {
  const name = typeof identity === "string" ? identity : identity.join("/");

  if (typeof index === "number") {
    return `${parent}.${index}.${name}`;
  }

  return parent ? `${parent}:.${name}` : name;
};

export const formatChildren = (
  children: string[][],
  questionsMap: Record<string, QuestionProps>,
): {key: string, params: QuestionProps}[] =>
  children.map((identity) => {
    const key = keyFromIdentity(identity);

    return { key, params: questionsMap[key] };
  });

export const getLayout = (formData: FormData): FormData["layouts"][0] => {
  const { layouts } = formData;
  const layout = find(layouts, (layoutItem) => layoutItem.name === FormLayoutName.APPLY);

  if (typeof layout === "undefined") {
    throw new Error("Expected form layout not found.");
  }

  return layout;
};

export const getSectionIndex =
(sectionData: string | undefined, layout: FormLayout): number => {
  if (!sectionData) return 0;
  return findIndex(layout.groups, (section) => section.name === sectionData);
};

export const findMatchingSection =
(questionIdentities: string[], questionSections: Record<string, string>, name: string):string => {
  const simpleFind = questionSections[name];
  if (simpleFind) return simpleFind;

  const key = questionIdentities.find((identity) => name.includes(identity)) || "";
  return questionSections[key];
};

export const getErrorCount = (errors: any): number => {
  if (!errors) return 0;
  if (typeof errors === "string") return 1;
  if (Array.isArray(errors)) {
    return errors.reduce((acc: number, error: any) => acc + getErrorCount(error), 0);
  }

  return Object.keys(errors).reduce((acc, key) => acc + getErrorCount(errors[key]), 0);
};
